<template>
	<section :id="['container-' + index + '-' + energyData.type]" :class="['container-' + energyData.type]">
		<div class="energy-table container-lg">
			<div class="row">
				<div :class="[energyData.config.showScala == true ? 'col-md-6' : 'col-12']">
					<div class="row">
						<div class="col-12">
							<h2 v-if="energyData.config.title">{{ energyData.config.title }}</h2>
						</div>
						<div v-if="!isDesktop" class="energy-table-inner col-12">
							<template v-for="(field, name, index) in energyData.config.fields" :key="index">
								<div class="table-row col-12">
									<div class="row" v-if="field !== '' && field !=='Nein' && field !=='-' && field !=='keine Angabe'">
										<div class="table-column col-6">
											<span>{{ name }}</span>
										</div>
		
										<div class="table-column col-6">
											<span class="table-icon" v-if="field === true">
												<svg version="1.1" id="Ebene_1" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" x="0px" y="0px" viewBox="0 -10 50 50" style="enable-background:new 0 0 44 42;" xml:space="preserve">
													<path id="Pfad_3373" class="st0" d="M2.5,14.7l13.6,13.6L42.5,2.8"/>
												</svg>
											</span>
											<span v-else class="energy-data" v-html="field"></span>
										</div>
									</div>
								</div>
							</template>
						</div>
						<div v-if="isDesktop" class="energy-table-inner col-12">
							<div class="row">
								<template v-for="(field, name, index) in energyData.config.fields" :key="index">
									<div class="table-row-desktop col-6">
										<div class="row table-column-desktop" v-if="field !== '' && field !=='Nein' && field !=='-' && field !=='keine Angabe'">
											<div class="energy-data-wrapper">
												<span class="col-12 table-icon" v-if="field === true">
													<svg version="1.1" id="Ebene_1" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" x="0px" y="0px" viewBox="0 -10 50 50" style="enable-background:new 0 0 44 42;" xml:space="preserve">
														<path id="Pfad_3373" class="st0" d="M2.5,14.7l13.6,13.6L42.5,2.8"/>
													</svg>
												</span> <br v-if="field === true">
												<span v-else class="col-12 energy-data" v-html="field"></span> <br v-if="field !== true">
												<span class="col-12 energy-name">{{ name }}</span>
											</div>
										</div>
									</div>
								</template>
							</div>
						</div>
					</div>
				</div>
	
				<div v-if="energyData.config.showScala == true" class="energy-image col-md-6 d-flex align-items-center justify-content-center">
					<img :src="energyData.config.path" alt="">
				</div>
			</div>
		</div>
        <hr class="horizontal-line">
	</section>
</template>

<script>

export default {
	props: {
		energyData: {
			type: Object
		},
		index: {
			type: Number
		},
	},
	data() {
		return {
		innerWidth: 0,
		}
	},
	created() {
		this.innerWidth = window.innerWidth;
		window.addEventListener('resize', () => {
			this.innerWidth = window.innerWidth;
		});
	},
	computed: {
		isDesktop() {
			return this.innerWidth >= 768;
		}
	},
};

</script>

<style lang="scss" scoped>
@import "@/assets/scss/design-turin/energyDataComponent.scss";
</style>